import type { inferParserType, Options, UrlKeys } from "nuqs"
import {
  createLoader,
  createSerializer,
  parseAsArrayOf,
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from "nuqs"
import { fspConfig } from "../init/fsp-config"
import {
  DEFAULT_FEEDBACK_PERIOD_DAYS,
  parseAsAllergens,
  parseAsDietTypes,
  parseAsDrawerMode,
  parseAsEnableSecondaryMarket,
  parseAsFeedbackMonthKey,
  parseAsFeedbackPeriod,
  parseAsOptionalTimeString,
  parseAsPrepState,
  parseAsSortDirection,
  parseAsStatus,
  parseAsTemperature,
} from "./search-params-custom-codecs"
export type TSearchParams = inferParserType<typeof spCodecs>

const spCodecs = {
  allergens: parseAsAllergens.withDefault([]),
  courseId: parseAsString.withDefault(""),
  dietTypes: parseAsDietTypes.withDefault([]),
  enableSecondaryMarket: parseAsEnableSecondaryMarket.withDefault(fspConfig.enableSecondaryMarket),
  feedbackFocusMonths: parseAsArrayOf(parseAsFeedbackMonthKey).withDefault([]),
  feedbackPeriod: parseAsFeedbackPeriod.withDefault(DEFAULT_FEEDBACK_PERIOD_DAYS),
  forcedAppTime: parseAsOptionalTimeString,
  mode: parseAsDrawerMode,
  page: parseAsInteger.withDefault(1),
  prepState: parseAsPrepState,
  redirect: parseAsString,
  search: parseAsString.withDefault(""),
  showInternalCourses: parseAsBoolean.withDefault(false),
  sort: parseAsSortDirection.withDefault("asc"),
  status: parseAsStatus.withDefault("all"),
  temperature: parseAsTemperature.withDefault("all"),
}

const urlKeys = {
  allergens: "al",
  courseId: "cid",
  dietTypes: "dt",
  enableSecondaryMarket: "esm",
  feedbackFocusMonths: "month",
  feedbackPeriod: "period",
  forcedAppTime: "fat",
  mode: "mode",
  page: "p",
  prepState: "ps",
  redirect: "r",
  search: "q",
  showInternalCourses: "sic",
  sort: "s",
  status: "st",
  temperature: "tmp",
} as const satisfies UrlKeys<typeof spCodecs>

export function useSp(options?: Options) {
  const resolvedOptions = { ...options, urlKeys }
  return useQueryStates(spCodecs, resolvedOptions)
}

export const loadSp = createLoader(spCodecs, { urlKeys })
export const serializeSp = createSerializer(spCodecs, { urlKeys })
